var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slice"},[_c('div',{staticClass:"vid-wrapper"},[_c('video',{ref:"vid",attrs:{"loop":"","width":_vm.vidSize,"height":_vm.vidSize},on:{"loadeddata":_vm.onLoaded}},[_c('source',{attrs:{"src":_vm.url}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }